import { useMediaQueryMatch } from './useMediaQueryMatch';

/** The md breakpoint (Chakra's 48em). Below it, the composer/dock treat the viewport as mobile. */
const MD_BREAKPOINT_QUERY = '(min-width: 48em)';

/**
 * Reactive "is the viewport below md" check, read synchronously so the first paint matches the
 * real width. useBreakpointValue resolves async — it returns the `base` value on first paint and
 * then snaps — which makes a fixed bar jump from the mobile offset to the desktop one. Reading
 * matchMedia up front avoids that snap.
 */
export function useIsMobileViewport(): boolean {
	return !useMediaQueryMatch(MD_BREAKPOINT_QUERY);
}
